// src/store/useDepartmentStore.js
import {
    create
} from 'zustand';

const useDepartmentStore = create((set) => ({
    departments: [],
    setDepartments: (departments) => set({
        departments
    }),
    addDepartment: (department) =>
        set((state) => ({
            departments: [...state.departments, department]
        })),
    updateDepartment: (updatedDept) =>
        set((state) => ({
            departments: state.departments.map((dept) =>
                dept.id === updatedDept.id ? updatedDept : dept
            ),
        })),
    deleteDepartment: (id) =>
        set((state) => ({
            departments: state.departments.filter((dept) => dept.id !== id),
        })),
}));

export default useDepartmentStore;